<div style="height: 100%">
  <div style="height: 20%">
    <h3>農場作業記録CSV出力</h3>
  </div>

  <div fxLayout="column" fxLayoutAlign="space-between" style="height: 80%">
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxLayout="column" fxLayoutAlign="center">農場名：　{{farmName}}</div>
      <mat-icon [matTooltip]="'農場に属する全鶏舎の作業記録CSVを出力'"
                matTooltipPosition="right">
        info_outline
      </mat-icon>
    </div>

      <!-- dateRangePickerを使う場合-->
      <!--      <mat-form-field appearance="legacy" class="date-range-picker-custom-padding">-->
      <!--        <mat-label>日付範囲</mat-label>-->
      <!--        &lt;!&ndash;    https://stackoverflow.com/a/64860373      &ndash;&gt;-->
      <!--        <mat-date-range-input style="padding: 0.5em"-->
      <!--                              [formGroup]="fgSagyouKirokuDateRange"-->
      <!--                              [rangePicker]="yoteiShukkaDateRangePicker">-->
      <!--          <input matStartDate placeholder="Start date" formControlName="fcStart"-->
      <!--                 (click)="yoteiShukkaDateRangePicker.open()" #fromDateInput readonly>-->
      <!--          <input matEndDate placeholder="End date" formControlName="fcEnd"-->
      <!--                 (click)="yoteiShukkaDateRangePicker.open()" #endDateInput readonly>-->
      <!--        </mat-date-range-input>-->
      <!--        <mat-datepicker-toggle matSuffix [for]="yoteiShukkaDateRangePicker" style="font-size: 20px;"></mat-datepicker-toggle>-->
      <!--        <mat-date-range-picker touchUi #yoteiShukkaDateRangePicker [maxRange]=maxRange disabled="false"></mat-date-range-picker>-->
      <!--      </mat-form-field>-->
      <!--      [(ngModel)]="fgSagyouKirokuDateRange.value.fcStart"-->

      <!-- dateRangePickerを使わない場合-->
      <div fxLayout="row wrap" fxLayoutGap="24px" [matTooltip]="'指定可能期間'+maxRange+'日'" matTooltipPosition="above">
        <mat-form-field appearance="legacy" class="input-width">
          <mat-label>開始日</mat-label>
          <input matInput
                 [matDatepicker]="sagyouKirokuDateFromPicker"
                 [formControl]="fgSagyouKirokuDateRange.get('fcStart') | formControl"
                 name="sagyouKirokuDateFrom"
                 readonly
                 required
                 [min]="commonService.genOffsetDateWithStandardDateString(fgSagyouKirokuDateRange.value.fcEnd, -this.maxRange)"
                 [max]="fgSagyouKirokuDateRange.value.fcEnd"
                 (click)="sagyouKirokuDateFromPicker.open()"
                 (dateChange)="onDateChanged()"
          >
          <mat-datepicker-toggle matSuffix [for]="sagyouKirokuDateFromPicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #sagyouKirokuDateFromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="legacy" class="input-width">
          <mat-label>終了日</mat-label>
          <input matInput
                 [matDatepicker]="sagyouKirokuDateToPicker"
                 [formControl]="fgSagyouKirokuDateRange.get('fcEnd') | formControl"
                 name="sagyouKirokuDateTo"
                 required
                 readonly
                 [min]="fgSagyouKirokuDateRange.value.fcStart"
                 [max]="commonService.getDateWithString()"
                 (click)="sagyouKirokuDateToPicker.open()"
                 (dateChange)="onDateChanged()"
          >
          <mat-datepicker-toggle matSuffix [for]="sagyouKirokuDateToPicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #sagyouKirokuDateToPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutAlign="center">
        <button mat-raised-button
                color="primary"
                style="height: 40px;width: 100px;margin-bottom: 8px"
                [disabled]="fgSagyouKirokuDateRange.invalid || !sagyouKirokuDateIsValid"
                (click)="onClickExportCSV()"
        >CSV出力
        </button>
      </div>

  </div>


</div>
